import { makeStyles } from 'tss-react/mui';

const useStylesImageLargeFormFieldUpload: MaterialUIStylesCallback = makeStyles()((): MaterialUIStyles => ({
  dropTargetBox: {
    width: 290,
    height: 225,
  },
  previewImage: {
    maxWidth: 270,
    maxHeight: 205,
  },
}));

export default useStylesImageLargeFormFieldUpload;
